export const ZOOM_STEPS = [0.25, 0.33, 0.5, 0.67, 0.75, 1, 1.25, 1.5, 2];

export function steppedZoom(current: number, direction: 1 | -1): number {
  if (direction > 0) {
    return ZOOM_STEPS.find((step) => step > current + 0.001) || ZOOM_STEPS[ZOOM_STEPS.length - 1];
  }
  return [...ZOOM_STEPS].reverse().find((step) => step < current - 0.001) || ZOOM_STEPS[0];
}

export function formatZoomPercent(scale: number): string {
  return `${Math.round(scale * 100)}%`;
}

export function isZoomKey(event: Pick<KeyboardEvent, 'key' | 'ctrlKey' | 'metaKey'>): 'in' | 'out' | 'fit' | null {
  if (!(event.ctrlKey || event.metaKey)) return null;
  if (event.key === '0') return 'fit';
  if (event.key === '-' || event.key === '_') return 'out';
  if (event.key === '=' || event.key === '+' || event.key === 'Add') return 'in';
  return null;
}
